import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiblingLinkComponent } from './sibling-link.component';



@NgModule({
  declarations: [SiblingLinkComponent],
  imports: [
   CommonModule
  ],
  exports: [SiblingLinkComponent],
})
export class SiblingLinkModule { }
